export const showFullName = (firstName: string, lastName: string) => {
  return `${firstName} ${lastName}`;
};
